export default __webpack_public_path__ + "static/federations-desktop-b03502e958e05dd6db17995d4e681c1f.svg";